import styled from "styled-components"
import { MEDIA_QUERIES } from "@constants"

export const InterviewBuilderPageContentDIV = styled.div`
  width: 100%;
  background: var(--color--cobalt-100);

  .container {
    position: relative;
  }
`

export const InterviewBuilderPageModalDIV = styled.div`
  text-align: center;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacing--S) var(--spacing--XS);

    .Button {
      width: 100%;
    }

    ${MEDIA_QUERIES.S} {
      flex-direction: row;

      .Button {
        width: auto;
      }
    }
  }

  p {
    margin-bottom: var(--spacing--S);
  }
`
